module.exports = __webpack_public_path__ + "public/img/whh_logo.3405b1fc.png";